import React, { useState, useEffect } from "react";
import { Row, Col, Form, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../config/firebase";
import PageHeader from "components/common/PageHeader";
import FalconComponentCard from "components/common/FalconComponentCard";
import constituencies from "../../config/constituencies";
import ActionModal from "./ActionModal";

const EditMember = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [memberData, setMemberData] = useState(null);
  const [constituencyData, setConstituencyData] = useState(null);
  const [selectedConstituency, setSelectedConstituency] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const id = window !== undefined && window.location.pathname.split("/").pop();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const apiUrl = `${process.env.REACT_APP_API_URL}`;
          const response1 = await axios.get(
            `${apiUrl}/members/constituencies/id/${id}`
          );
          const response2 = await axios.get(`${apiUrl}/members/id/${id}`);

          setConstituencyData(response1.data);
          setMemberData(response2.data[0]);

          setLoading(false);
        } catch (err) {
          console.log("Error", err);
        }
      } else {
        navigate("/members/list");
      }
    };

    fetchData();
  }, []);

  const getConstituencyName = (constituencyId) => {
    const constituency = constituencies.find(
      (constituency) => constituency.value === constituencyId
    );
    return constituency ? constituency.name : "";
  };

  const handleCreateModalClose = () => {
    setSelectedConstituency(null);
    setShowCreateModal(false);
  };

  const handleDeleteModalClose = () => {
    setSelectedConstituency(null);
    setShowDeleteModal(false);
  };

  const handleDeleteClick = (constituency) => {
    setSelectedConstituency(constituency);
    setShowDeleteModal(true);
  };

  const handleDeleteRole = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/members/archive/constituency/${selectedConstituency.id}`;
      const response = await axios.delete(apiUrl);

      if (response.status === 200) {
        toast.success("Constituency deleted successfully", {
          theme: "colored",
        });
        console.log("constituencyData", constituencyData);
        console.log("selectedConstituency.id", selectedConstituency.id);
        const newConstituencyData = constituencyData.filter(
          (constituency) => constituency.id !== selectedConstituency.id
        );
        setConstituencyData(newConstituencyData);
        handleDeleteModalClose();
      } else {
        toast.error("Failed to delete role", {
          theme: "colored",
        });
      }
    } catch (err) {
      console.error("Error", err.message);
      toast.error(`Error: ${err.message}`, {
        theme: "colored",
      });
    }
  };

  const handleConstituencyChange = (e) => {
    console.log("selectedConstituency", e.target.value);
    const constituency_id = e.target.value;
    setSelectedConstituency({
      ...selectedConstituency,
      constituency_id,
    });
  };

  const handleModalCreateConstituency = () => {
    setShowCreateModal(true);
  };

  const handleSaveNew = async () => {
    console.log("selectedConstituency", selectedConstituency, id);
    if (!selectedConstituency?.constituency_id || id == null) {
      toast.error("Please select a constituency", {
        theme: "colored",
      });
      return;
    }
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/members/create/constituency/${selectedConstituency.constituency_id}/member/${id}`;
      const response = await axios.post(apiUrl);

      if (response.status === 200) {
        toast.success("Constituency created successfully", {
          theme: "colored",
        });
        const newConstituencyData = [...constituencyData, selectedConstituency];
        setConstituencyData(newConstituencyData);
        handleCreateModalClose();
      } else {
        toast.error("Failed to create constituency", {
          theme: "colored",
        });
      }
    } catch (err) {
      console.error("Error", err.message);
      toast.error(`Error: ${err.message}`, {
        theme: "colored",
      });
    }
  };

  return (
    <>
      <PageHeader
        title="Manage a Member's Constituencies"
        description="The updated Member details will be shown on the Member's page"
        className="mb-3"
      ></PageHeader>

      {!loading ? (
        <FalconComponentCard>
          <FalconComponentCard.Header
            title={`Member: ${memberData?.name} ${memberData?.surname}`}
            light={false}
            noPreview={true}
          ></FalconComponentCard.Header>

          {!loading && (
            <FalconComponentCard.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {constituencyData.length > 0 &&
                    constituencyData.map((constituency) => (
                      <tr>
                        <td>
                          {getConstituencyName(
                            constituency?.constituency_id.toString()
                          )}
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => handleDeleteClick(constituency)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              <ActionModal
                show={showCreateModal}
                handleClose={handleCreateModalClose}
                title="Add constituency"
                handleSave={handleSaveNew}
              >
                <Form.Group>
                  <Form.Label>Constituency</Form.Label>
                  <Form.Control as="select" onChange={handleConstituencyChange}>
                    {constituencies.map((constituency) => (
                      <option value={constituency.value}>
                        {constituency.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </ActionModal>

              <ActionModal
                show={showDeleteModal}
                handleClose={handleDeleteModalClose}
                title="Delete constituency"
                handleSave={handleDeleteRole}
              >
                <p>Are you sure you want to delete this constituency?</p>
              </ActionModal>

              <Row>
                <Col lg="6" className="mt-4 mb-3 ml-3">
                  <Form.Group>
                    <Button
                      variant="primary"
                      onClick={handleModalCreateConstituency}
                    >
                      Add new constituency for {memberData.name}
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </FalconComponentCard.Body>
          )}
        </FalconComponentCard>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default EditMember;
